module.exports = __webpack_public_path__ + "media/images/emblems/Buch_am_Irchel-blazon-0da454f73dfef8c0872849ac2110b75a.svg";